
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute, useRouter } from "vue-router";
// import globalScript from '@/global';
import Page from '@/components/Page.vue';
import scripts from '@/assets/car-detail.js';

import { fetchStockDetail } from '@/api/car';
import { StockDetail } from '@/api/car/type';



export default defineComponent({
  components: {
    Page,
  },
  setup () {
    const route = useRoute();
    const router = useRouter();
    const chassisNumber = String(route.params.chassisNumber);
    const scoreComments = ref(comments);
    const loading = ref(true);
    const data = ref<StockDetail>();

    onMounted(async () => {
      try {
        const fetched = await fetchStockDetail(chassisNumber);
        // console.log(fetched);
        data.value = fetched.data;
        loading.value = false;
        setTimeout(() => {
          scripts.carDetailScript(data?.value?.imageComments || []);
        }, 100);
      } catch (e) {
        console.error(e);
        router.push('/no-data');
      }
    });

    const statusText = {
      0: '申し込む',
      1: '商談中',
      2: '契約手続中',
      3: '契約手続中',
      4: '利用中',
      5: '準備中',
    };

    return {
      router,
      loading,
      data,
      scoreComments,
      formatYearMonth,
      statusText,
    };
  },
});

const comments = {
  'S': 'ほぼ新車の状態で、内外装、無傷・無補修の状態です。',
  '6': '内外装、無傷、無補修の状態です。',
  '5': '目立たない傷、凹みなどが少しあるが、概ね良好な状態です。',
  '4.5': '小さなキズ、凹み・軽微な修理跡があるが、そのまま加修せずに十分に乗れる状態です。',
  '4': '目立つ傷、凹みなどが少しあり、加修が必要と思われる箇所が数カ所ある状態です。',
  '3.5': '大小の加修を必要とする箇所が数カ所ある状態又は外板②適用車です。',
  '3': '大小の加修を必要とする箇所が多数ある状態です。',
  '2': '加修を必要とする箇所が車両全体にある状態です。',
  '1': '消化材散布車・冠水車（歴車を含む）',
  'R': '修復歴車',
};

const formatYearMonth = (yearMonth: string): string[] => {
  const out = [];
  const source = String(yearMonth);
  out[0] = source.slice(0,4);
  out[1] = source.slice(4,6).replace(/^0/, '');
  return out;
};
